import type { PpvStatistics } from '@/modules/chatting/types'

import AvgPriceIcon from '../../../../icons/ppv-avg-price.svg'
import BuyRateIcon from '../../../../icons/ppv-buy-rate.svg'
import LastPurchaseIcon from '../../../../icons/ppv-last-purchase.svg'
import MaxPriceIcon from '../../../../icons/ppv-max-price.svg'
import { getRelativeDate } from '../utils'

export function getPPVStatistics(data: PpvStatistics) {
  const { averagePrice, maximumPrice, totalCount, boughtCount, lastPurchase } =
    data
  const buyRate = Math.round(((boughtCount / totalCount) * 100 * 10) / 10)
  const buyRateString = buyRate + '% (' + boughtCount + '/' + totalCount + ')'

  return [
    {
      icon: AvgPriceIcon,
      label: 'Avg. price: ' + (averagePrice === 0 ? '-' : `$${averagePrice}`),
    },
    {
      icon: MaxPriceIcon,
      label: 'Max price: ' + (maximumPrice === 0 ? '-' : `$${maximumPrice}`),
    },
    {
      icon: BuyRateIcon,
      label: 'Buy rate: ' + (totalCount === 0 ? '-' : buyRateString),
    },
    {
      icon: LastPurchaseIcon,
      label:
        'Last purchase: ' +
        (lastPurchase ? getRelativeDate(lastPurchase) : '-'),
    },
  ]
}
